
import { callAPI } from './callAPI';
import { jwtDecode } from "jwt-decode";
import { initAppNames } from './apps';

export const loginUser = async (username, password) => {
    try {
        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', password);
        const response = await callAPI.post("/auth/login", formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        const { token, refresh_token } = response.data
        localStorage.setItem('token', token);
        localStorage.setItem('refresh_token', refresh_token);
        // const infos = jwtDecode(token)

        await initAppNames();

        return "ok";
    } catch (error) {
        console.error('Error during login:', error);
        throw error;
    }
};

export const sudoUser = async (username) => {
    try {
        const formData = new URLSearchParams();
        formData.append('username', username);
        const response = await callAPI.post("/admin/sudo", formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        const { token, refresh_token } = response.data
        const sudoer = {}
        sudoer.adm_token = localStorage.getItem('token')
        sudoer.adm_refresh_token = localStorage.getItem('refresh_token')
        localStorage.setItem('sudoer_token', JSON.stringify(sudoer));

        localStorage.setItem('token', token);
        localStorage.setItem('refresh_token', refresh_token);
        localStorage.removeItem('allowed_apps');
        localStorage.removeItem('active_app');
        // const infos = jwtDecode(token)

        await initAppNames();

        return "ok";
    } catch (error) {
        console.error('Error during login:', error);
        throw error;
    }
};

export const releaseSudo = async () => {
    const sudoerStr = localStorage.getItem('sudoer_token');
    if (!sudoerStr) return;

    const sudoer = JSON.parse(sudoerStr);
    localStorage.setItem('token', sudoer.adm_token);
    localStorage.setItem('refresh_token', sudoer.adm_refresh_token);
    localStorage.removeItem('sudoer_token');
    localStorage.removeItem('allowed_apps');

    // const infos = jwtDecode(token)
    await initAppNames();
    window.location.reload();
    return "ok";
}

export const logoutUser = async () => {
    localStorage.removeItem('token');
    const refresh_token = localStorage.getItem('refresh_token')
    localStorage.removeItem('refresh_token');
    if (localStorage.getItem('refresh_token')) {
        try {
            const response = await callAPI.post("/auth/invalidate_token", { refresh_token });
            return response.data;
        } catch (error) {
            console.error('Error during logout:', error);
            throw error;
        }
    }
};

export const rolesMap = {
    admin: 1,
    compte: 2,
    hotels: 4,
    campings: 8,
    fvt: 16,
    offres: 32,
    airdna: 64,
    mkg: 128,
    AUTHENTICATED: 255,
}

export function getUserInfos() {
    const token = localStorage.getItem('token')
    if (!token) return null;

    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
}

export function hasRole(role) {
    const token = localStorage.getItem('token')
    if (!token) window.location.href = '/login';

    const { roles } = jwtDecode(token)
    const userRoles = JSON.parse(roles).map(role => rolesMap[role]).reduce((sum, num) => sum + num, 0);

    return (userRoles & role) > 0;
}

export function redirectIfNotGranted(role) {
    if (!hasRole(role)) window.location.href = '/login';
}